<template>
  <div class="show-more">
    <div @click="changeMore">
      <p>
        <span>
          {{isMore ? '收起信息' : '了解更多'}}
        </span>
        <a-icon v-if="isMore" type="caret-up" @click="changeMore" />
        <a-icon v-else type="caret-down" @click="changeMore" />
      </p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ShowMore',
  props: {
    isMore: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {

    }
  },
  methods: {
    changeMore() {
      this.$emit('changeMore')
    }
  }
}
</script>

<style lang="less" scoped>
.show-more {
  text-align: center;
  div {
    display: inline-block;
    cursor: pointer;
    &:hover {
      color: #06b880;
    }
  }
  p {
    line-height: 20px;
    display: flex;
    align-items: center;
    span {
      padding-right: 12px;
    }
  }
}
</style>
